import React from 'react';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { ReviewItem } from '../Review/components/ReviewItem';
import { DafYear, DafYearOption } from '../../api/useCharitableGivingQuery';

const getGrantYearValue = (grantYear: DafYear | null, yearOptions: DafYearOption[]) => {
  if (!grantYear) {
    return '—';
  }

  if (grantYear.type === 0) {
    return grantYear.year;
  }

  const foundOption = yearOptions.find(({ type }) => type === grantYear.type);

  return foundOption?.label ?? '—';
};

export const DafGrantYearReview = () => {
  const {
    workflow: {
      data: { dafGrantStartYear, dafGrantEndYear },
      options: { dafStartYearOptions, dafEndYearOptions },
    },
  } = useCharitableGivingContext();

  const dafStartYearValue = getGrantYearValue(dafGrantStartYear, dafStartYearOptions);
  const dafEndYearValue = getGrantYearValue(dafGrantEndYear, dafEndYearOptions);

  return (
    <>
      <ReviewItem
        label={dafGrantEndYear ? 'Grant Start Year' : 'Grant Year'}
        value={dafStartYearValue || '—'}
      />

      {dafGrantEndYear && <ReviewItem label="Grant End Year" value={dafEndYearValue} />}
    </>
  );
};
